var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgIcSoundOnSmall = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M13.075 5.159a.75.75 0 0 1 .41.668v12.346a.75.75 0 0 1-1.192.606L8.17 15.775H5.529a2.06 2.06 0 0 1-2.062-2.063v-3.424c0-1.14.923-2.063 2.062-2.063h2.64l4.124-3.004a.75.75 0 0 1 .782-.062m-1.09 2.143-3.13 2.28a.75.75 0 0 1-.441.143H5.529a.56.56 0 0 0-.562.563v3.424c0 .31.251.563.562.563h2.885a.75.75 0 0 1 .442.143l3.129 2.28zm3.252 1.72a.75.75 0 0 0 .257 1.029c.884.53 1.256 1.273 1.256 1.949 0 .675-.372 1.419-1.256 1.95a.75.75 0 0 0 .772 1.286c1.276-.766 1.984-1.967 1.984-3.236s-.708-2.47-1.984-3.236a.75.75 0 0 0-1.03.258m2.018-1.59a.75.75 0 1 1 .852-1.234c4.186 2.89 4.195 8.715 0 11.605a.75.75 0 0 1-.852-1.236c3.329-2.292 3.325-6.84 0-9.135",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcSoundOnSmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };